module.exports = __webpack_public_path__ + "static/media/signup.684566af.png";